import { TeacherSidebarLinkItems } from '@grcs/views/shared/components/navigation/SidebarLinkItems/TeacherSidebarLinkItems';
import { SidebarWithHeader } from '@grcs/views/shared/components/navigation/SidebarWithHeader';
import { TeacherProtectedRoute } from '../ProtectedRoute/TeacherProtectedRoute';

export const TeacherSidebarWrapper: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  return (
    <TeacherProtectedRoute>
      <SidebarWithHeader sidebarItems={TeacherSidebarLinkItems}>
        {children}
      </SidebarWithHeader>
    </TeacherProtectedRoute>
  );
};
